import {appInstance} from '@/utils/app-accessor'

export const useWeatherStore = defineStore('weather', () => {
    const weather = ref({})

    function SET_WEATHER(val: object) {
        weather.value = val
    }

    async function loadWeather({cityName, latitude, longitude, units, lang, cnt, cityId}: any) {
        try {
            const weatherResponse = await appInstance.$api.weather.get({
                cityName,
                latitude,
                longitude,
                units,
                lang,
                cnt,
            })
            await setWeatherResponse(weatherResponse, cityId)
        } catch (e) {
            SET_WEATHER({})
        }
    }

    async function setWeatherResponse(weatherResponse: any, cityId: string | number) {
        const localForage = await appInstance.$localForage.getItem('weather')
        const weather = localForage ? localForage : {}
        weather[cityId] = weatherResponse
        appInstance.$localForage.setItem('weather', weather)
        SET_WEATHER(weather)
    }

    return {weather, SET_WEATHER, loadWeather}
})

// TODO [P3] Need check this HRM improvement. Relates with https://pinia.vuejs.org/cookbook/hot-module-replacement.html#HMR-Hot-Module-Replacement-
if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(useWeatherStore, import.meta.hot))
